import './fxhash.min.js';
import './init.ts';
